import { connect } from 'react-redux';
import { setBackButtonPath, setPageTitle } from '../layout/layout.actions';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import queryString from 'query-string';

import { Box } from '@material-ui/core';
import { getReportByLink, reports } from './reportDefinitions.js';
import TableauReportWrapper from './tableauReportWrapper.component';
import {
  getSelectedClientInformation, 
  userHasPermission, 
  isHPClient, 
  isSouthwireClient, 
  isCRHClient, 
  isBattellePNNLClient, 
  isSamsungClient,
  isMPCClient,
  isRoyalCaribbeanClient,
  isDruryHotelsClient,
  isKomatsuClient,
  isSQLTestClient,
} from '../../utilities/authUtils';

class ReportPage extends Component {
  constructor(props) {
    super(props);

    const reportLink = props.match.params.name;
    const clientInfo = getSelectedClientInformation();
    this.query = queryString.parse(props.location.search);
    this.currentClientId = clientInfo ? clientInfo.id : null;
    this.currentReport = getReportByLink(reportLink, clientInfo ? clientInfo.id : null);

    if (this.currentReport) {
      this.props.setPageTitle(`${this.currentReport.name} Report`);
    }
    this.props.setBackButtonPath('/reporting');

    this.getReportForm = this.getReportForm.bind(this);
    this.isFormAuthorized = this.isFormAuthorized.bind(this);
  }

  getReportForm(reportName) {
    const report = reports.find((report) => report.link === reportName);
    if (report) {
      return report.form ? report.form : <div />;
    }
    return <div>Error: Form not found.</div>;
  }

  // authorize by permission name
  isFormAuthorized(report, clientDivisions) {
    if (report) {

      if (report.permissionName) {
        return userHasPermission(report.permissionName, clientDivisions);
      }

      return true;
    }
    return false;
  }

  handleCustomReportPaths(reportPath = '', clientDivisions) {

    let environment = process.env.REACT_APP_ANALYTICS_ENV;
    let newReportPath = reportPath;

    //AB#403 - Handle custom report path for FMP Auth Report (by Auth0 permission)
    if (this.currentReport.tableauReport && this.currentReport.link === 'authorizations' && userHasPermission('reports:fmpauthreport', clientDivisions)) {
      newReportPath = 'views/Authorizations{{env}}/Dashboard';
    }

    //AB#486 - Handle custom report paths for McCarthy reports (by Auth0 permissions)
    if (this.currentReport.tableauReport && this.currentReport.link === 'authorizations'   && userHasPermission('reports:McCarthyAuthReport', clientDivisions)) {
      newReportPath = 'views/McCarthyAuthorizations{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'closedproperty'   && userHasPermission('reports:McCarthyClosedPropertyReport', clientDivisions)) {
      newReportPath = 'views/McCarthyClosedPropertiesDetail{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'costreport'       && userHasPermission('reports:McCarthyCostReport', clientDivisions)) {
      newReportPath = 'views/McCarthyCost{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'activeproperties' && userHasPermission('reports:McCarthyActivePropertyReport', clientDivisions)) {
      newReportPath = 'views/McCarthyActiveProperties{{env}}/Dashboard';
    }

    //AB#666 - Handle custom report paths for H&P reports (by ClientId; No Auth0 permissions)
    if (this.currentReport.tableauReport && this.currentReport.link === 'authorizations'   && isHPClient() === true) {
      newReportPath = 'views/AuthorizationsOnly-HP{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'activeproperties' && isHPClient() === true) {
      newReportPath = 'views/ActiveProperties-HP{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'closedproperty'   && isHPClient() === true) {
      newReportPath = 'views/ClosedPropertiesDetail-HP{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'costreport'       && isHPClient() === true) {
      newReportPath = 'views/Cost-HP{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'policyexceptions' && isHPClient() === true) {
      newReportPath = 'views/PolicyExceptions-HP{{env}}/Dashboard';
    }
    if (this.currentReport.tableauReport && this.currentReport.link === 'evalbytransferee' && isHPClient() === true) {
      newReportPath = 'views/ServiceEvaluation-HP{{env}}/Dashboard';
    }

    //AB#1031 - Handle custom report paths for CRH reports (by Environment; by ClientId; No Auth0 permissions)
    if (isCRHClient() === true) {
      if (environment === 'production') {
        if (this.currentReport.tableauReport && this.currentReport.link === 'authorizations') {
          newReportPath = 'views/AuthorizationsOnlyCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'activeproperties') {
          newReportPath = 'views/ActivePropertiesCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'closedproperty') {
          newReportPath = 'views/ClosedPropertiesDetailCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'costreport') {
          newReportPath = 'views/CostCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'policyexceptions') {
          newReportPath = 'views/PolicyExceptionsCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'evalbytransferee') {
          newReportPath = 'views/ServiceEvaluationCRH/Dashboard';
        }
      } else {
        if (this.currentReport.tableauReport && this.currentReport.link === 'authorizations') {
          newReportPath = 'views/AuthorizationsOnlyTestCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'activeproperties') {
          newReportPath = 'views/ActivePropertiesTestCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'closedproperty') {
          newReportPath = 'views/ClosedPropertiesDetailTestCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'costreport') {
          newReportPath = 'views/Cost-CRHTest/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'policyexceptions') {
          newReportPath = 'views/PolicyExceptionsTestCRH/Dashboard';
        }
        if (this.currentReport.tableauReport && this.currentReport.link === 'evalbytransferee') {
          newReportPath = 'views/ServiceEvaluationTestCRH/Dashboard';
        }
      }
    }

    //AB#943 - Handle custom Cost Report paths for "Southwire Company" Client reports (by ClientId; No Auth0 permissions)
    if (this.currentReport.tableauReport && this.currentReport.link === 'costreport' && isSouthwireClient() === true) {
      if(environment === 'dev') {
        newReportPath = 'views/CostDev-Southwire/Dashboard';
      } else if(environment === 'test' || environment === 'stage') {
        newReportPath = 'views/CostTestSouthwire/Dashboard';
      } else if(environment === 'production') {
        newReportPath = 'views/Cost-Southwire/Dashboard';
      }
    }

    //AB#1356 - Handle custom report paths for "Battelle PNNL" Client reports (by ClientId; With Auth0 permissions)
    if (this.currentReport.tableauReport && isBattellePNNLClient() === true && userHasPermission('reports:BattellePNNL', clientDivisions) === true) {
      if (environment === 'dev') {
        if (this.currentReport.permissionName === 'reports:BattellePNNL') {
          switch (this.currentReport.link) {
            case 'battellepnnlactivefiles':
              newReportPath = 'views/ActiveFiles-PNNLDev/Dashboard1';
              break;
            default:
              newReportPath = '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-PNNLDEV/Dashboard';
              break;
            case 'costreport':
              newReportPath = 'views/Cost-PNNLDev/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "Dev");
          };
        }
      } else if (environment === 'test' || environment === 'stage') {
        if (this.currentReport.permissionName === 'reports:BattellePNNL') {
          switch (this.currentReport.link) {
            case 'battellepnnlactivefiles':
              newReportPath = 'views/ActiveFiles-PNNLTest/Dashboard1';
              break;
            default:
              newReportPath = '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-PNNLTEST/Dashboard';
              break;
            case 'costreport':
              newReportPath = 'views/Cost-PNNLTest/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "Test");
          };
        }
      } else if (environment === 'production') {
        if (this.currentReport.permissionName === 'reports:BattellePNNL') {
          switch (this.currentReport.link) {
            case 'battellepnnlactivefiles':
              newReportPath = 'views/ActiveFiles-PNNL/Dashboard1';
              break;
            default:
              newReportPath = '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-PNNL/Dashboard';
              break;
            case 'costreport':
              newReportPath = 'views/Cost-PNNL/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "");
          };
        }
      }
    }

    //AB#1356 - Handle custom report paths for "Samsung" Client reports (by ClientId; With Auth0 permissions)
    if (this.currentReport.tableauReport && isSamsungClient() === true && userHasPermission('reports:Samsung', clientDivisions) === true) {
      if (environment === 'dev') {
        if (this.currentReport.permissionName === 'reports:Samsung') {
          switch (this.currentReport.link) {
            case 'samsungactivefiles':
              newReportPath = 'views/ActiveFiles-SamsungDev/Dashboard1';
              break;
            case 'samsungcost':
              newReportPath = 'views/Cost-SamsungDev/Dashboard';
              break;
            case 'samsungsascost':
              newReportPath = 'views/SamsungSASCostbyExpenseDev/Dashboard1';
              break;
            case 'samsungsralumpsumcost':
              newReportPath = 'views/SRALumpSumCost-Dev/Dashboard1';
              break;
            case 'samsungsraexceptions':
              newReportPath = 'views/SRAExceptionsDev/Dashboard1';
              break;
            default:
              newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-SamsungDev/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "Dev");
          };
        }
      } else if (environment === 'test' || environment === 'stage') {
        if (this.currentReport.permissionName === 'reports:Samsung') {
          switch (this.currentReport.link) {
            case 'samsungactivefiles':
              newReportPath = 'views/ActiveFiles-SamsungTest/Dashboard1';
              break;
            case 'samsungcost':
              newReportPath = 'views/Cost-SamsungTest/Dashboard';
              break;
            case 'samsungsascost':
              newReportPath = 'views/SamsungSASCostbyExpenseTest/Dashboard1';
              break;
            case 'samsungsralumpsumcost':
              newReportPath = 'views/SRALumpSumTest/Dashboard1';
              break;
            case 'samsungsraexceptions':
              newReportPath = 'views/SRAExceptionsTest/Dashboard1';
              break;
            default:
              newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-SamsungTest/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "Test");
          };
        }
      } else if (environment === 'production') {
        if (this.currentReport.permissionName === 'reports:Samsung') {
          switch (this.currentReport.link) {
            case 'samsungactivefiles':
              newReportPath = 'views/ActiveFiles-Samsung/Dashboard1';
              break;
            case 'samsungcost':
              newReportPath = 'views/Cost-Samsung/Dashboard';
              break;
            case 'samsungsascost':
              newReportPath = 'views/SamsungSASCost/Dashboard1';
              break;
            case 'samsungsralumpsumcost':
              newReportPath = 'views/SRALumpSumCost/Dashboard1';
              break;
            case 'samsungsraexceptions':
              newReportPath = 'views/SRAExceptions/Dashboard1';
              break;
            default:
              newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
          };
        } else {
          switch (this.currentReport.link) {
            case 'authorizations':
              newReportPath = 'views/AuthorizationsOnly-Samsung/Dashboard';
              break;
            default:
              newReportPath = this.currentReport.reportPath.replace("{{env}}", "");
          };
        }
      }
    }

    //AB#1576 - Handle custom report path for "MPC" Client report (by ClientId; With Auth0 permissions)
    if (this.currentReport.tableauReport && isMPCClient() === true && userHasPermission('reports:mpcHSRRSP', clientDivisions) === true) {
      if (this.currentReport.link === 'mpchsrrsp' && this.currentReport.permissionName === 'reports:mpcHSRRSP') {
        if (environment === 'dev') {
          newReportPath = 'views/MPCHSRRSPReport-Dev/Dashboard1';
        } else if (environment === 'test' || environment === 'stage') {
          newReportPath = 'views/MPCHSRRSPReport/Dashboard1';
        } else if (environment === 'production') {
          newReportPath = 'views/MPCHSRRSPReport-Prod/Dashboard1';
        }
      }
    }

    //AB#1586 - Handle custom report paths for "Royal Caribbean" Client reports (by ClientId; With Auth0 permissions)
    if (this.currentReport.tableauReport && isRoyalCaribbeanClient() === true && this.currentReport.permissionName) {
      if (environment === 'dev') {
        switch (this.currentReport.link) {
          case 'royalcaribbeanfilestatusintl':
            newReportPath = 'views/RoyalCaribbeanINTLFileStatus-DEV/Dashboard';
            break;
          case 'royalcaribbeanfilestatusdomestic':
            newReportPath = 'views/RoyalCaribbeanDomFileStatus-DEV/Dashboard1';
            break;
          default:
            newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
        };
      } else if (environment === 'test' || environment === 'stage') {
        switch (this.currentReport.link) {
          case 'royalcaribbeanfilestatusintl':
            newReportPath = 'views/RoyalCaribbeanINTLFileStatus-Test/Dashboard';
            break;
          case 'royalcaribbeanfilestatusdomestic':
            newReportPath = 'views/RoyalCaribbeanDomFileStatus-Test/Dashboard1';
            break;
          default:
            newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
        };
      } else if (environment === 'production') {
        switch (this.currentReport.link) {
          case 'royalcaribbeanfilestatusintl':
            newReportPath = 'views/RoyalCaribbeanINTLFileStatus/Dashboard';
            break;
          case 'royalcaribbeanfilestatusdomestic':
            newReportPath = 'views/RoyalCaribbeanDomFileStatus/Dashboard1';
            break;
          default:
            newReportPath = this.currentReport.reportPath ? this.currentReport.reportPath : '';
        };
      }
    }

    //AB#1787 - Handle custom report paths for Drury Hotels Client - Replace standard report URL paths with the requested custom paths.
    if (this.currentReport.tableauReport && this.currentReport.reportPath && isDruryHotelsClient() === true) {
      if (this.currentReport.link && this.currentReport.link === 'costreport') {
        newReportPath = 'views/DruryCost{{env}}/Dashboard';
      }
      if (this.currentReport.link && this.currentReport.link === 'policyexceptions') {
        newReportPath = 'views/DruryPolicyExceptions{{env}}/Dashboard';
      }
    }

    //AB#1835 - Handle custom report paths for Komatsu Mining Corp Client - Replace standard Cost report URL paths with the requested custom paths.
    if (this.currentReport.tableauReport && this.currentReport.reportPath && isKomatsuClient() === true) {
      if (this.currentReport.link && this.currentReport.link === 'costreport') {
        newReportPath = 'views/KomatsuCost{{env}}/Dashboard1';
      }
      if (this.currentReport.link && this.currentReport.link === 'policyexceptions') {
        newReportPath = 'views/KomatsuPolicyExceptions{{env}}/Dashboard';
      }
    }

    //Added via AB#1405 to handle the testing of connecting Tableau Reports directly to our SQL DB.
    //This is only for the Clients 152 (Sandia) and 247 (Demo Corp) in the DEV & TEST environments ONLY.
    if (this.currentReport.tableauReport && this.currentReport.link === 'authorizationstestsqldb' && isSQLTestClient() === true) {
      newReportPath = 'views/AuthorizationsOnlyTest-SQLDirect/Dashboard';
    }

    if (newReportPath.includes('{{env}}')) {
      // must match the "Test" suffix used by every published Tableau workbook/view in
      // the test environment (and every other client-specific override in this file) -
      // "Staging" doesn't correspond to any actual view, causing embed error code 16
      const environmentSuffix = environment === 'dev'
        ? 'Dev'
        : environment === 'test' || environment === 'stage'
        ? 'Test'
        : '';
      newReportPath = newReportPath.replace('{{env}}', environmentSuffix);
    }

    return newReportPath;

  }
  
  render() {
    let { clientDivisions } = this.props;

    // if no report was found for the selected path
    // redirect to list of reports
    if (!this.currentReport || !this.isFormAuthorized(this.currentReport, clientDivisions)) {
      this.props.history.push('/reporting');
      return null;
    }
    const reportParameters = {
      ...(this.query ? this.query : null),
    };

    const reportPath = this.currentReport.reportPath;

    return (
      this.currentReport.tableauReport ?
        <Box padding="2rem" height="100%">
          <TableauReportWrapper reportPath={reportPath} reportParameters={reportParameters} />
        </Box>
        :
        <Box padding="2rem">
          <h4>Select the parameters below to filter your report.  You may leave any of the non-required items blank to return full set of information</h4>
          {this.getReportForm(this.currentReport.link)}
        </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    clientDivisions: state.layout.get('clientDivisions'),
    userContact: state.layout.get('userContact'),
  };
};

export default withRouter(connect(mapStateToProps, {
  setPageTitle,
  setBackButtonPath,
})(ReportPage));
